import packageJson from '../../../package.json';
import { env } from './env';

const version = `v${packageJson.version}`;

export const appVersion = env ? `${version} (${env})` : version;
